// @flow
import React from 'react';
import styled from 'styled-components';
import { media } from 'styles/Mixins';
import _ from 'lodash';
import { HomeApplication } from 'utils/ExportCommon';
import { font } from 'styles/Constants';

const ModalWindow = styled.div`
  display: ${props => (props.visible ? 'block' : 'none')};
  position: fixed;
  z-index: 100;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
`;

const ModalContent = styled.div`
  background-color: #fefefe;
  margin: auto;
  padding: 40px 70px;
  border: 1px solid #888;
  color: red;
  width: 500px;
  border-radius: 2px;
  background-color: #278c7e;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  ${media.xs`
    width: 345px;
    min-height: 324px;
    padding: 30px 45px;
  `}
`;

const TextModal = styled.div`
  color: #ffffff;
  font-family: ${font.openSans};
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  margin-top: 20px;
  ${media.xs`
    width: 100%;
  `}
`;

const ImgContent = styled.div`
  margin-left: calc(50% - 82.5px);
  height: 165px;
  width: 165px;
  background-color: #ffffff;
  border-radius: 50%;
  ${media.xs`
    margin: 0 auto;
  `}
`;

type State = {};

type PropsType = {
  visible: boolean,
  close: () => void,
  autocloseTiming: number
};

export default class CanceledHomeApplicationModal extends React.Component<
  PropsType,
  State
> {
  render() {
    if (this.props.visible) {
      _.delay(this.props.close, this.props.autocloseTiming);
    }

    return (
      <div>
        <ModalWindow visible={this.props.visible}>
          <ModalContent>
            <ImgContent>
              <img
                style={{
                  height: '100px',
                  marginTop: '35px',
                  marginLeft: '32px'
                }}
                src={HomeApplication.SadFace}
              />
            </ImgContent>
            <TextModal>
              Tu aplicación esta cancelada, si necesitas ayuda contacta al
              equipo de Homie +52 55 6943 7235
            </TextModal>
          </ModalContent>
        </ModalWindow>
      </div>
    );
  }
}
